export const ProductionDivisionMock = {
  title: 'Production (KMT)',
  type: 'PRODUCTION_DIVISION',
  navigation: {
    type: 'GraphNavigation',
    nav: {
      month: [
        {
          title: 'LY',
          graph: {
            data: [
              {
                // BU
                title: 'Potash',
                subtitle: 'Total',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                // BU
                title: 'Sdom',
                subtitle: 'Potash',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  }
                ],
              },
              {
                // BU
                title: 'IBP',
                subtitle: 'Potash',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                // BU
                title: 'Sdom',
                subtitle: 'Magnesium',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },

        },
        {
          title: 'BGT',
          graph: {
            data: [
              {
                // BU
                title: 'Potash',
                subtitle: 'Total',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                // BU
                title: 'Sdom',
                subtitle: 'Potash',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                // BU
                title: 'IBP',
                subtitle: 'Potash',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                // BU
                title: 'Sdom',
                subtitle: 'Magnesium',
                data: [
                  //SBU
                  {
                    title: 'Total',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 200.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 50.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 12.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 130.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Granular',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 332.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 111.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                  {
                    title: 'Standart',
                    data: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 146.0,
                            percent: 35.0,
                          },
                          compare: {
                            value: 108.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 141.0,
                            percent: -42.0,
                          },
                          compare: {
                            value: 244.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Mar',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 443.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Apr',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 168.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'May',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 411.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Jun',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 0.0,
                            percent: 0,
                          },
                          compare: {
                            value: 373.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        }
      ],
    },
  },
  subMenu: [
    {
      // NavigationItem
      title: 'Potash',
      subtitle: 'Total',
      data: [
        {
          //SubNavigationItem
          title: 'Total',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 1000,
            addUp: 1200,
            budget: 1300,
            cols: [
              {
                //RTSparkChartColumn
                value: 50,
                date: '06/01/2022',
                colName: '01',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/02/2022',
                colName: '02',
                colGroupName: 'June 2022',
              },
              {
                value: 450,
                date: '06/03/2022',
                colName: '03',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/04/2022',
                colName: '04',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/05/2022',
                colName: '05',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/06/2022',
                colName: '06',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/07/2022',
                colName: '07',
                colGroupName: 'June 2022',
              },
              {
                value: 350,
                date: '06/09/2022',
                colName: '08',
                colGroupName: 'June 2022',
              },
              {
                value: 250,
                date: '06/09/2022',
                colName: '09',
                colGroupName: 'June 2022',
              },
              {
                value: 200,
                date: '06/10/2022',
                colName: '10',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/11/2022',
                colName: '11',
                colGroupName: 'June 2022',
              },
              {
                value: 0,
                date: '06/12/2022',
                colName: '12',
                colGroupName: 'June 2022',
              },
              {
                value: 0,
                date: '06/13/2022',
                colName: '13',
                colGroupName: 'June 2022',
              },
              {
                value: 0,
                date: '06/14/2022',
                colName: '14',
                colGroupName: 'June 2022',
              },
              {
                value: 0,
                date: '06/15/2022',
                colName: '15',
                colGroupName: 'June 2022',
              },
              {
                //RTSparkChartColumn
                value: 500,
                date: '06/16/2022',
                colName: '16',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/17/2022',
                colName: '17',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/18/2022',
                colName: '18',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/19/2022',
                colName: '19',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/20/2022',
                colName: '20',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/21/2022',
                colName: '21',
                colGroupName: 'June 2022',
              },
              {
                value: 990,
                date: '06/22/2022',
                colName: '22',
                colGroupName: 'June 2022',
              },
              {
                value: 900,
                date: '06/23/2022',
                colName: '23',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/24/2022',
                colName: '24',
                colGroupName: 'June 2022',
              },
              {
                value: 1300,
                date: '06/25/2022',
                colName: '25',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/26/2022',
                colName: '26',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/27/2022',
                colName: '27',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/28/2022',
                colName: '28',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/29/2022',
                colName: '29',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/30/2022',
                colName: '30',
                colGroupName: 'June 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Granular',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Standart',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
      ],
    },
    {
      // NavigationItem
      title: 'Sdom',
      subtitle: 'Potash',
      data: [
        {
          //SubNavigationItem
          title: 'Total',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 2800,
            addUp: 2500,
            budget: 3300,
            cols: [
              {
                //RTSparkChartColumn
                value: 50,
                date: '06/01/2022',
                colName: '01',
                colGroupName: 'June 2022',
              },
              {
                value: 877,
                date: '06/02/2022',
                colName: '02',
                colGroupName: 'June 2022',
              },
              {
                value: 255,
                date: '06/03/2022',
                colName: '03',
                colGroupName: 'June 2022',
              },
              {
                value: 788,
                date: '06/04/2022',
                colName: '04',
                colGroupName: 'June 2022',
              },
              {
                value: 555,
                date: '06/05/2022',
                colName: '05',
                colGroupName: 'June 2022',
              },
              {
                value: 32,
                date: '06/06/2022',
                colName: '06',
                colGroupName: 'June 2022',
              },
              {
                value: 23,
                date: '06/07/2022',
                colName: '07',
                colGroupName: 'June 2022',
              },
              {
                value: 350,
                date: '06/09/2022',
                colName: '08',
                colGroupName: 'June 2022',
              },
              {
                value: 250,
                date: '06/09/2022',
                colName: '09',
                colGroupName: 'June 2022',
              },
              {
                value: 200,
                date: '06/10/2022',
                colName: '10',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/11/2022',
                colName: '11',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/12/2022',
                colName: '12',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/13/2022',
                colName: '13',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/14/2022',
                colName: '14',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/15/2022',
                colName: '15',
                colGroupName: 'June 2022',
              },
              {
                //RTSparkChartColumn
                value: 500,
                date: '06/16/2022',
                colName: '16',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/17/2022',
                colName: '17',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/18/2022',
                colName: '18',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/19/2022',
                colName: '19',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/20/2022',
                colName: '20',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/21/2022',
                colName: '21',
                colGroupName: 'June 2022',
              },
              {
                value: 990,
                date: '06/22/2022',
                colName: '22',
                colGroupName: 'June 2022',
              },
              {
                value: 900,
                date: '06/23/2022',
                colName: '23',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/24/2022',
                colName: '24',
                colGroupName: 'June 2022',
              },
              {
                value: 1300,
                date: '06/25/2022',
                colName: '25',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/26/2022',
                colName: '26',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/27/2022',
                colName: '27',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/28/2022',
                colName: '28',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/29/2022',
                colName: '29',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/30/2022',
                colName: '30',
                colGroupName: 'June 2022',
              },
            ],
          },
        }
      ],
    },
    {
      // NavigationItem
      title: 'IBP',
      subtitle: 'Potash',
      data: [
        {
          //SubNavigationItem
          title: 'Total',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 1000,
            addUp: 1200,
            budget: 1300,
            cols: [
              {
                //RTSparkChartColumn
                value: 50,
                date: '06/01/2022',
                colName: '01',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/02/2022',
                colName: '02',
                colGroupName: 'June 2022',
              },
              {
                value: 450,
                date: '06/03/2022',
                colName: '03',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/04/2022',
                colName: '04',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/05/2022',
                colName: '05',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/06/2022',
                colName: '06',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/07/2022',
                colName: '07',
                colGroupName: 'June 2022',
              },
              {
                value: 350,
                date: '06/09/2022',
                colName: '08',
                colGroupName: 'June 2022',
              },
              {
                value: 250,
                date: '06/09/2022',
                colName: '09',
                colGroupName: 'June 2022',
              },
              {
                value: 200,
                date: '06/10/2022',
                colName: '10',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/11/2022',
                colName: '11',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/12/2022',
                colName: '12',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/13/2022',
                colName: '13',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/14/2022',
                colName: '14',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/15/2022',
                colName: '15',
                colGroupName: 'June 2022',
              },
              {
                //RTSparkChartColumn
                value: 500,
                date: '06/16/2022',
                colName: '16',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/17/2022',
                colName: '17',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/18/2022',
                colName: '18',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/19/2022',
                colName: '19',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/20/2022',
                colName: '20',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/21/2022',
                colName: '21',
                colGroupName: 'June 2022',
              },
              {
                value: 990,
                date: '06/22/2022',
                colName: '22',
                colGroupName: 'June 2022',
              },
              {
                value: 900,
                date: '06/23/2022',
                colName: '23',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/24/2022',
                colName: '24',
                colGroupName: 'June 2022',
              },
              {
                value: 1300,
                date: '06/25/2022',
                colName: '25',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/26/2022',
                colName: '26',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/27/2022',
                colName: '27',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/28/2022',
                colName: '28',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/29/2022',
                colName: '29',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/30/2022',
                colName: '30',
                colGroupName: 'June 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Granular',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Standart',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
      ],
    },
    {
      // NavigationItem
      title: 'Sdom',
      subtitle: 'Magnesium',
      data: [
        {
          //SubNavigationItem
          title: 'Total',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 1000,
            addUp: 1200,
            budget: 1300,
            cols: [
              {
                //RTSparkChartColumn
                value: 50,
                date: '06/01/2022',
                colName: '01',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/02/2022',
                colName: '02',
                colGroupName: 'June 2022',
              },
              {
                value: 450,
                date: '06/03/2022',
                colName: '03',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/04/2022',
                colName: '04',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/05/2022',
                colName: '05',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/06/2022',
                colName: '06',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/07/2022',
                colName: '07',
                colGroupName: 'June 2022',
              },
              {
                value: 350,
                date: '06/09/2022',
                colName: '08',
                colGroupName: 'June 2022',
              },
              {
                value: 250,
                date: '06/09/2022',
                colName: '09',
                colGroupName: 'June 2022',
              },
              {
                value: 200,
                date: '06/10/2022',
                colName: '10',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/11/2022',
                colName: '11',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/12/2022',
                colName: '12',
                colGroupName: 'June 2022',
              },
              {
                value: 400,
                date: '06/13/2022',
                colName: '13',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/14/2022',
                colName: '14',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/15/2022',
                colName: '15',
                colGroupName: 'June 2022',
              },
              {
                //RTSparkChartColumn
                value: 500,
                date: '06/16/2022',
                colName: '16',
                colGroupName: 'June 2022',
              },
              {
                value: 500,
                date: '06/17/2022',
                colName: '17',
                colGroupName: 'June 2022',
              },
              {
                value: 600,
                date: '06/18/2022',
                colName: '18',
                colGroupName: 'June 2022',
              },
              {
                value: 800,
                date: '06/19/2022',
                colName: '19',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/20/2022',
                colName: '20',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/21/2022',
                colName: '21',
                colGroupName: 'June 2022',
              },
              {
                value: 990,
                date: '06/22/2022',
                colName: '22',
                colGroupName: 'June 2022',
              },
              {
                value: 900,
                date: '06/23/2022',
                colName: '23',
                colGroupName: 'June 2022',
              },
              {
                value: 1050,
                date: '06/24/2022',
                colName: '24',
                colGroupName: 'June 2022',
              },
              {
                value: 1300,
                date: '06/25/2022',
                colName: '25',
                colGroupName: 'June 2022',
              },
              {
                value: 1200,
                date: '06/26/2022',
                colName: '26',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/27/2022',
                colName: '27',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/28/2022',
                colName: '28',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/29/2022',
                colName: '29',
                colGroupName: 'June 2022',
              },
              {
                value: null,
                date: '06/30/2022',
                colName: '30',
                colGroupName: 'June 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Granular',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
        {
          //SubNavigationItem
          title: 'Standart',
          data: {
            // RTSparkChart
            yAxisTitle: 'BGT',
            averageValue: 500,
            addUp: 1100,
            budget: 1400,
            cols: [
              {
                //RTSparkChartColumn
                value: 150,
                date: '11/01/2022',
                colName: '01',
                colGroupName: 'November 2022',
              },
              {
                value: 60,
                date: '11/02/2022',
                colName: '02',
                colGroupName: 'November 2022',
              },
              {
                value: 105,
                date: '11/03/2022',
                colName: '03',
                colGroupName: 'November 2022',
              },
              {
                value: 220,
                date: '11/04/2022',
                colName: '04',
                colGroupName: 'November 2022',
              },
              {
                value: 340,
                date: '11/05/2022',
                colName: '05',
                colGroupName: 'November 2022',
              },
              {
                value: 610,
                date: '11/06/2022',
                colName: '06',
                colGroupName: 'November 2022',
              },
              {
                value: 500,
                date: '11/07/2022',
                colName: '07',
                colGroupName: 'November 2022',
              },
              {
                value: 350,
                date: '11/09/2022',
                colName: '08',
                colGroupName: 'November 2022',
              },
              {
                value: 550,
                date: '11/09/2022',
                colName: '09',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/10/2022',
                colName: '10',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/11/2022',
                colName: '11',
                colGroupName: 'November 2022',
              },
              {
                value: 95,
                date: '11/12/2022',
                colName: '12',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/13/2022',
                colName: '13',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/14/2022',
                colName: '14',
                colGroupName: 'November 2022',
              },
              {
                value: 450,
                date: '11/15/2022',
                colName: '15',
                colGroupName: 'November 2022',
              },
              {
                //RTSparkChartColumn
                value: 230,
                date: '11/16/2022',
                colName: '16',
                colGroupName: 'November 2022',
              },
              {
                value: 150,
                date: '11/17/2022',
                colName: '17',
                colGroupName: 'November 2022',
              },
              {
                value: 200,
                date: '11/18/2022',
                colName: '18',
                colGroupName: 'November 2022',
              },
              {
                value: 520,
                date: '11/19/2022',
                colName: '19',
                colGroupName: 'November 2022',
              },
              {
                value: 600,
                date: '11/20/2022',
                colName: '20',
                colGroupName: 'November 2022',
              },
              {
                value: 230,
                date: '11/21/2022',
                colName: '21',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/22/2022',
                colName: '22',
                colGroupName: 'November 2022',
              },
              {
                value: 400,
                date: '11/23/2022',
                colName: '23',
                colGroupName: 'November 2022',
              },
              {
                value: 490,
                date: '11/24/2022',
                colName: '24',
                colGroupName: 'November 2022',
              },
              {
                value: 590,
                date: '11/25/2022',
                colName: '25',
                colGroupName: 'November 2022',
              },
              {
                value: 300,
                date: '11/26/2022',
                colName: '26',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/27/2022',
                colName: '27',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/28/2022',
                colName: '28',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/29/2022',
                colName: '29',
                colGroupName: 'November 2022',
              },
              {
                value: null,
                date: '11/30/2022',
                colName: '30',
                colGroupName: 'November 2022',
              },
            ],
          },
        },
      ],
    },

  ],
};

